module.exports = __webpack_public_path__ + "media/favicon/favicon-16x16-f98b4847f7abaa9e713fc525c037d26d.png";